// 3rd party
import * as React from 'react';
import { useHistory } from 'react-router-dom';

// Bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// Shared UI
import { LocalizedText, useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';

// Models
import { Product } from 'models';

interface UnsupportedLanguageDialogProps {
  dialogId: string;
  product: Product;
  routeStore: RouteStore;
  onOpen?: () => void;
  onCancel?: () => void;
  onContinue?: () => void;
  onDismiss?: () => void;
  onClose?: () => void;
}

function UnsupportedLanguageDialog({
  dialogId,
  product,
  routeStore,
  onOpen,
  onCancel,
  onContinue,
  onDismiss,
  onClose,
}: UnsupportedLanguageDialogProps) {
  const history = useHistory();
  const l10n = useLocalization();

  function handleDialogOpen() {
    // TODO: Add open tracking

    onOpen?.();
  }

  function handleDialogClose() {
    // TODO: Add close tracking

    routeStore.closeDialog();

    onClose?.();
  }

  function handleLayerDismiss() {
    // TODO: Add dismiss tracking

    onDismiss?.();

    handleDialogClose();
  }

  function handleDialogCancelButtonClick() {
    // TODO: Add cancel tracking

    onCancel?.();

    handleDialogClose();
  }

  function handleDialogContinueButtonClick() {
    // TODO: Add continue tracking

    setTimeout(() => {
      if (product.isExternal) {
        window.open(product.link, '_blank');
      } else {
        history.push(product.link);
      }
    }, 0);

    onContinue?.();

    handleDialogClose();
  }

  return (
    <DialogRoute id={dialogId}>
      <Layer id="dialogUnsupportedLanguage" onDismiss={handleLayerDismiss}>
        <UitkDialog
          dialogShow={true}
          returnFocusOnClose={true}
          openCallback={handleDialogOpen}
          closeCallback={handleDialogClose}
        >
          <UitkDialogContent>
            <UitkHeading tag="h3" size={5}>
              <LocalizedText message="products.unsupported-language-dialog.title.unsupported_language" />
            </UitkHeading>

            <UitkParagraph size={1}>
              <LocalizedText message="products.unsupported-language-dialog.content.product_supported_in_english_only" />
            </UitkParagraph>
          </UitkDialogContent>

          <UitkDialogFooter
            buttonOne={{
              type: 'tertiary',
              text: l10n.formatText('products.unsupported-language-dialog.action.cancel'),
              onClick: handleDialogCancelButtonClick,
            }}
            buttonTwo={{
              type: 'primary',
              text: l10n.formatText('products.unsupported-language-dialog.action.continue'),
              onClick: handleDialogContinueButtonClick,
            }}
          />
        </UitkDialog>
      </Layer>
    </DialogRoute>
  );
}

export { UnsupportedLanguageDialog };
